import {
 CargoVanIcon,
 DefaultBoxTruckIcon,
 LargeStraightRollIcon,
 SmallStraightIcon,
 SprinterIcon,
} from "@/components/illustrations/trucks/box-truck-icons";
import {
 ContainerIcon,
 DropDeckDoubleIcon,
 DropDeckSingleIcon,
 FlatbedIcon,
 Trailer48Icon,
 Trailer53Icon,
 TrailerRollIcon,
} from "@/components/illustrations/trucks/trailer-icons";

interface TruckIconProps {
 truckId: string;
}

export function TruckIcon({ truckId }: TruckIconProps) {
 const isContainer = truckId.includes("container");
 const isLong = truckId.includes("53-trailer") || truckId.includes("drop");
 const viewBoxWidth = isContainer
  ? 36
  : truckId.includes("53-trailer") || truckId.includes("flatbed")
   ? 48
   : truckId === "48-trailer"
    ? 36
    : isLong
     ? 32
     : 24;

 return (
  <svg
   viewBox={`0 0 ${viewBoxWidth} 22`}
   className="w-full h-12"
   strokeLinecap="round"
   strokeLinejoin="round"
  >
   {isContainer ? (
    <ContainerIcon />
   ) : truckId === "drop-deck-single" ? (
    <DropDeckSingleIcon />
   ) : truckId === "drop-deck-double" ? (
    <DropDeckDoubleIcon />
   ) : truckId === "53-trailer-roll" ? (
    <TrailerRollIcon />
   ) : truckId === "cargo-van" ? (
    <CargoVanIcon />
   ) : truckId === "sprinter" ? (
    <SprinterIcon />
   ) : truckId === "small-straight" ? (
    <SmallStraightIcon />
   ) : truckId === "large-straight-roll" ? (
    <LargeStraightRollIcon />
   ) : truckId.includes("flatbed") ? (
    <FlatbedIcon />
   ) : truckId.includes("53-trailer") ? (
    <Trailer53Icon />
   ) : truckId.includes("trailer") || truckId.includes("48") ? (
    <Trailer48Icon />
   ) : (
    <DefaultBoxTruckIcon />
   )}
  </svg>
 );
}
